import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { FaShirt } from "react-icons/fa6";
import axios from 'axios';
import useGoogleMaps from '../../hooks/useGoogleMaps';

const googleAPIKey = 'AIzaSyBxCvxWFfaPdNpwDOO47RDGrV2U1xu8lZM';

function GameDetailPage() {
    const { gameId } = useParams(); // Extract the team ID from the URL
    const [gameDetails, setGameDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const mapRef = useRef(null);
    const google = useGoogleMaps(googleAPIKey);

    useEffect(() => {
        axios
            .get(`/api/games/${gameId}/`, {
                withCredentials: true,
            })
            .then((response) => {
                setGameDetails(response.data);
                setLoading(false);
            })
            .catch((error) => {
                console.error('Error fetching team details:', error);
                setError('Failed to load team details.');
                setLoading(false);
            });
    }, [gameId]);

    useEffect(() => {
        if (!google || !gameDetails) return;


        const { formatted_address: address } = gameDetails;

        /* Geocode the address just once */
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({ address }, (results, status) => {
            if (status !== "OK" || !results[0]) return;

            const map = new google.maps.Map(mapRef.current, {
                center: results[0].geometry.location,
                zoom: 14,
                mapId: 'e7e04a9922ec37551a45eaad',
                mapTypeControl: false,
                fullscreenControl: false,
            });


            const { AdvancedMarkerElement } = google.maps.marker;
            new AdvancedMarkerElement({
                map,
                position: results[0].geometry.location,
            });
        });
        return () => {
            if (mapRef.current) mapRef.current.innerHTML = "";
        };
    }, [google, gameDetails]);

    if (loading) {
        return <div className="container">Loading team details...</div>;
    }

    if (error) {
        return <div className="container text-danger">{error}</div>;
    }
    const homeParticipant = gameDetails.participants?.find((p) => p.is_home && p.content_type === 'team') || {};
    const awayParticipant = gameDetails.participants?.find((p) => p.is_away && p.content_type === 'team') || {};

    const homePlayers = homeParticipant.team_players || [];
    const awayPlayers = awayParticipant.team_players || [];

    return (
        <>
            {/* Card START */}
            <div className="card card-body border-0 mb-3"
                style={{
                    backgroundImage: `url(${process.env.PUBLIC_URL}/images/kb_static/Kickball_League_Banner.png)`,
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    height: '250px',  // Match the original image height
                    width: '100%',
                }}
            >
                <div className="row justify-content-between">
                    {/* Date START */}
                    <div className="col-lg-2 ms-auto">
                        <div className="bg-mode text-center rounded overflow-hidden p-1 d-inline-block">
                            <div className="bg-primary p-2 text-white rounded-top small lh-1">{gameDetails.scheduled_day_of_week}</div>
                            <h5 className="mb-0 py-2 lh-1">{gameDetails.scheduled_date_only}</h5>
                            <p className="small mb-0">{gameDetails.scheduled_time_only}</p>
                        </div>
                    </div>
                </div>
            </div>
            {/* Card END */}

            <div className="card card-body mb-3">
                <div className="row g-4">
                    <div className="col-5 text-center">
                        <h2>{homeParticipant.participant_name}</h2>
                        <div className="avatar avatar-xxl mb-3">
                            <img
                                className="avatar-img rounded-circle border border-white border-3"
                                src={homeParticipant.participant_logo}
                                alt={`${homeParticipant.participant_name} logo`}
                                style={{ backgroundColor: "white" }}
                            />
                        </div>
                        <h5>Home</h5>
                    </div>
                    <div className="col-2 d-flex align-items-center justify-content-center">
                        <div>
                            <h2>VS.</h2>
                        </div>
                    </div>
                    <div className="col-5 text-center">
                        <h2>{awayParticipant.participant_name}</h2>
                        <div className="avatar avatar-xxl mb-3">
                            <img
                                className="avatar-img rounded-circle border border-white border-3"
                                src={awayParticipant.participant_logo}
                                alt={`${awayParticipant.participant_name} logo`}
                                style={{ backgroundColor: "white" }}
                            />
                        </div>
                        <h5>Away</h5>
                    </div>
                </div>
            </div>


            <div className="card card-body mb-2">
                <div className="row">
                    <div className="col-6 d-flex flex-column justify-content-center">
                        <h5 className="mb-4 text-center">Game Details:</h5>
                        <ul className="list-unstyled">
                            <li className="d-flex justify-content-between mb-3">
                                <strong className="w-100px">Date:</strong>
                                <span className="text-end">{gameDetails.scheduled_date_only}</span>
                            </li>
                            <li className="d-flex justify-content-between mb-3">
                                <strong className="w-100px">Time:</strong>
                                <span className="text-end">{gameDetails.scheduled_time_only}</span>
                            </li>
                            <li className="d-flex justify-content-between mb-3">
                                <strong className="w-100px">Address:</strong>
                                <div className="text-end">
                                    <div>{gameDetails.location.street_1} {gameDetails.location.street_2}</div>
                                    <div>{gameDetails.location.city}, {gameDetails.location.state}</div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div className="col-6">
                        <div
                            ref={mapRef}
                            style={{ width: "100%", height: 230, borderRadius: 4 }}
                            className="grayscale"
                        />
                    </div>
                </div>
            </div>
            <div className="row g-4">
                <div className="col-12 col-sm-6">
                    <div className="card">
                        <div className="card-header border-0">
                            <div className="row d-flex text-center align-items-center justify-content-between">
                                <div className="col-6">
                                    <h5 className="card-title">Team Captain</h5>
                                    <p className="small mb-0"> {homeParticipant.team_captain || 'No Captain'} </p>
                                </div>
                                <div className="col-6">
                                    <h5 className="card-title">Team Color</h5>
                                    <p className="small mb-0"><FaShirt style={{ fontSize: '20px', color: homeParticipant.team_color.value }}></FaShirt> {homeParticipant.team_color.name}</p>
                                </div>
                            </div>
                        </div>
                        <div className="container p-3 d-flex align-items-center justify-content-between">
                            <div className="col-sm-4 d-flex align-items-center justify-content-center">
                                <div className="d-flex">
                                    <i className="bi bi-trophy fs-4"></i>
                                    <div className="ms-3">
                                        <h5 className="mb-0">{homeParticipant.team_wins}</h5>
                                        <p className="mb-0">Wins</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-4 d-flex align-items-center justify-content-center">
                                <div className="d-flex">
                                    <i className="bi bi-trophy-fill fs-4"></i>
                                    <div className="ms-3">
                                        <h5 className="mb-0">{homeParticipant.team_losses}</h5>
                                        <p className="mb-0">Losses</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-4 d-flex align-items-center justify-content-center">
                                <div className="d-flex">
                                    <i className="bi bi-trophy-fill fs-4"></i>
                                    <div className="ms-3">
                                        <h5 className="mb-0">{homeParticipant.team_draws}</h5>
                                        <p className="mb-0">Draws</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-header border-0">
                            <h5 className="card-title">Players</h5>
                        </div>
                        <div className="card-body pt-0">
                            <div className="row">
                                {homePlayers.map((player) => (
                                    <div key={player.id} className="col-6 col-sm-12 d-flex flex-wrap align-items-center mb-3">
                                        <div className="avatar avatar-md">
                                            <img
                                                className="avatar-img rounded-circle"
                                                src={
                                                    player.profile_picture ||
                                                    `${process.env.PUBLIC_URL}/images/kb_static/KLOC_circle.svg`
                                                }
                                                alt={`${player.first_name} ${player.last_name}`}
                                            />
                                        </div>
                                        <div className="ms-sm-2 my-2 my-sm-0">
                                            <h6 className="mb-0">{player.first_name} {player.last_name}</h6>
                                            <p className="small mb-0">
                                                <i className="bi bi-geo-alt pe-1"></i>Lemont
                                            </p>
                                        </div>
                                        <div className="ms-sm-auto mt-2 mt-sm-0">
                                            <input
                                                type="checkbox"
                                                className="btn-check"
                                                id={`Interested-${player.id}`}
                                                checked={player.attending}
                                                disabled
                                            />
                                            <label
                                                className="btn btn-sm btn-outline-success"
                                                htmlFor={`Interested-${player.id}`}
                                            >
                                                <i className="fa-solid fa-thumbs-up me-1"></i> Attending
                                            </label>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-sm-6">
                    <div className="card">
                        <div className="card-header border-0">
                            <div className="row d-flex text-center align-items-center justify-content-between">
                                <div className="col-6">
                                    <h5 className="card-title">Team Captain</h5>
                                    <p className="small mb-0"> {awayParticipant.team_captain || 'No Captain'} </p>
                                </div>
                                <div className="col-6">
                                    <h5 className="card-title">Team Color</h5>
                                    <p className="small mb-0"><FaShirt style={{ fontSize: '20px', color: awayParticipant.team_color.value }}></FaShirt> {awayParticipant.team_color.name}</p>
                                </div>
                            </div>
                        </div>
                        <div className="container p-3 d-flex align-items-center justify-content-between">
                            <div className="col-sm-4 d-flex align-items-center justify-content-center">
                                <div className="d-flex">
                                    <i className="bi bi-trophy fs-4"></i>
                                    <div className="ms-3">
                                        <h5 className="mb-0">{awayParticipant.team_wins}</h5>
                                        <p className="mb-0">Wins</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-4 d-flex align-items-center justify-content-center">
                                <div className="d-flex">
                                    <i className="bi bi-trophy-fill fs-4"></i>
                                    <div className="ms-3">
                                        <h5 className="mb-0">{awayParticipant.team_losses}</h5>
                                        <p className="mb-0">Losses</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-4 d-flex align-items-center justify-content-center">
                                <div className="d-flex">
                                    <i className="bi bi-trophy-fill fs-4"></i>
                                    <div className="ms-3">
                                        <h5 className="mb-0">{awayParticipant.team_draws}</h5>
                                        <p className="mb-0">Draws</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-header border-0">
                            <h5 className="card-title">Players</h5>
                        </div>
                        <div className="card-body pt-0">
                            <div className="row">
                                {awayPlayers.map((player) => (
                                    <div key={player.id} className="col-6 col-sm-12 d-flex flex-wrap align-items-center mb-3">
                                        <div className="avatar avatar-md">
                                            <img className="avatar-img rounded-circle"
                                                src={
                                                    player.profile_picture ||
                                                    `${process.env.PUBLIC_URL}/images/kb_static/KLOC_circle.svg`
                                                }
                                                alt={`${player.first_name} ${player.last_name}`}
                                            />
                                        </div>
                                        <div className="ms-sm-2 my-2 my-sm-0">
                                            <h6 className="mb-0">{player.first_name} {player.last_name}</h6>
                                            <p className="small mb-0"> <i className="bi bi-geo-alt pe-1"></i>Lemont </p>
                                        </div>
                                        <div className="ms-sm-auto mt-2 mt-sm-0">
                                            <input
                                                type="checkbox"
                                                className="btn-check"
                                                id={`Interested-${player.id}`}
                                                checked={player.attending}
                                                disabled
                                            />
                                            <label
                                                className="btn btn-sm btn-outline-success"
                                                htmlFor={`Interested-${player.id}`}
                                            >
                                                <i className="fa-solid fa-thumbs-up me-1"></i> Attending
                                            </label>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default GameDetailPage;
